<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div style="display:flex;justify-content: space-between;width:100%;">
                <div>
                  <el-button type="primary" size="medium" plain @click="back">上一步</el-button>


                  <el-tooltip class="item" effect="dark" content="开始导入表格中的数据" placement="top">
                    <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>
                  </el-tooltip>

                </div>


              </div>
            </el-row>
          </div>
        </div>
        <div class="rowTipStyle" style="text-align: center;">
        </div>
        <div style="padding: 10px;">

          <div width="100%">

            <div style="text-align: center;font-size:16px;margin-bottom: 5px;">
              点击单元格中的文字可以将其设置为本列列名;如不导入该列请不要设置该列列名;点击红色字体列名可修改列名称.</div>

            <!--            <div style="text-align: center;font-size:16px;margin-bottom: 5px;color:red;">
              注意：如果原表填写方式是按照列填写的，需要点“旋转表格”将表格改成行模式，否则导入后填表人无法正确填写表格。
            </div> -->


            <el-table ref="dataList" :data="dataList" style="width: 100%" empty-text="这里将会是填表人填好的数据" border
              @header-click="clickHeader" :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="500"
              highlight-current-row>
              <el-table-column width="100%" header-align="center" resizable align="center" :key="index"
                :label="header.label" :prop="header.prop" v-for="(header,index) in headList">
                <template slot="header" slot-scope="scope">
                  <div class="columnTitleStyle">
                    <div style="text-decoration: underline;color:lightgray;" v-if="header.label==header.prop">
                      {{header.label}}
                    </div>
                    <div style="font-size:16px;" v-else>
                      <div>

                        <div v-if="header.optional==0">
                          <el-tooltip class="item" effect="light" content="要求填表人必须填写列">

                            <div>
                              <div style="text-decoration: underline;color:red;">{{header.label}}</div>
                              <div style="font-size:12px;">{{header.data_type}} 必填</div>
                            </div>



                          </el-tooltip>
                        </div>
                        <div v-else>
                          <el-tooltip class="item" effect="dark" content="禁止修改和填写">

                            <div>
                              <div style="text-decoration: underline;">{{header.label}}</div>
                              <div style="font-size:12px;">{{header.data_type}} 选填</div>
                            </div>

                          </el-tooltip>
                        </div>

                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="color: red;margin: 10px;">注:如果在此界面上看不到任何数据,说明导入错误,请联系客服解决。客服微信 wx34424698</div>
          </div>

        </div>

      </el-col>
    </el-row>

    <!-- Form -->
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="表格预览" :visible.sync="selectColumnTitleDialogVisible"
      height="50%" width="70%">
      <el-form :model="form">
        <div>

          <div>

            <div>
              <div v-if="import_type=='0'" style="font-size: 18px;color:red;margin-bottom: 10px;">
                即将导入的数据收集表格样式如下，请务必注意检查表头是否正确:</div>
              <div v-else style="font-size: 18px;color:red;margin-bottom: 10px;">
                即将导入的数据收集表格样式如下：</div>
            </div>

            <el-table ref="dataList" :data="dataList" style="width: 100%" empty-text="这里将会是填表人填好的数据" border res
              :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="300">
              <el-table-column header-align="center" resizable align="center" :key="index" :label="header.label"
                :prop="header.prop" v-for="(header,index) in previewDataList">
                <template slot="header" slot-scope="scope">
                  <div class="columnTitleStyle">
                    <div v-if="import_type==0">
                      <div v-if="header.optional==0">
                        <el-tooltip class="item" effect="light" content="允许填写">
                          <!-- <span style=""><span style="color:red;">*</span>{{header.label}}</span> -->
                        </el-tooltip>
                      </div>
                      <div v-else>
                        <el-tooltip class="item" effect="dark" content="不可填写"><span>{{header.label}}</span></el-tooltip>
                      </div>
                    </div>
                    <div v-else>
                      <span style="">{{header.label}}</span>
                    </div>

                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" header-align="center" fixed="right" align="center" width="120"
                v-if="is_import_data==true">
                <template slot-scope="scope">
                  <div>
                    <el-button @click.native.prevent="deleteRow(scope.$index, dataList)" type="text" size="small">
                      <div>删除</div>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>

      <!--      <div v-if="import_type==0">
        <div style="font-size: 14px;text-align: center;margin-top:20px;color:red;">*:
          表示填表人必须填写的列</div>
      </div> -->


      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="nextPage">下一步</el-button>
      </div>
    </el-dialog>

    <!--表格名称-->
    <el-dialog width="60%" :close-on-click-modal="false" title="输入表格名称" :visible.sync="inputFormNameDialogVisible">
      <div class="colStyle">
        <el-input v-model="form_name" placeholder="输入表格名称" style="100%"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="inputFormNameDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="confrimFormName()">导 入</el-button>
      </div>
    </el-dialog>

    <!--修改表头-->
    <el-dialog width="50%" :close-on-click-modal="false" title="设置列属性" :visible.sync="headLabelDialogVisible">
      <div style="display: flex;align-items: center;">
        <div>数据列名：</div>
        <div style="width: 60%;">
          <el-input v-model="currentHeaderContent" placeholder="输入该列的名称"></el-input>
        </div>
      </div>

      <div style="display: flex;align-items: center;margin-top: 10px;">
        <div>数据格式：</div>
        <div style="width: 60%;">
          <el-select v-model="selectedTypeValue" placeholder="请选择数据格式">
            <el-option v-for="dataType in dataTypes" :key="dataType.value" :label="dataType.label"
              :value="dataType.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="display: flex;align-items: center;margin-top: 10px;">
        <div>是否必填：</div>
        <div style="width: 80%;">
          <el-select v-model="selectedEditTypeValue" placeholder="请选择">
            <el-option v-for="editType in editTypes" :key="editType.value" :label="editType.label"
              :value="editType.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="display: flex;align-items: center;margin-top: 10px;">
        <div>填写要求：</div>
        <div style="width: 60%;">
          <el-input type="textarea" v-model="currentHeaderComment" placeholder="输入填写要求"></el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="headLabelDialogVisible=false">取 消</el-button>
        <el-button @click="deleteHeaderInfo()" v-if="currentHeaderContent!==''">删 除</el-button>
        <el-button type="primary" @click="confirmHeaderInfo()">确 定</el-button>
      </div>
    </el-dialog>

    <!--是否输入数据确认窗口-->
    <el-dialog width="55%" :close-on-click-modal="false" title="请选择导入表格的用途"
      :visible.sync="importDataConfirmDialogVisible">
      <div style="text-align: left;">
        <div style="font-size:18px;">两种用途,请选择一个:</div>
      </div>
      <div style="font-size:22px;">
        <el-radio-group v-model="import_type" @change="changeImportType">
          <div style="margin: 20px;font-size:16px;">
            <el-radio :label="0">用<span style="color:red;">空表格</span>收集全部数据.填表人需要填写所有数据,用于<span
                style="color:red;">收集数据</span>.</el-radio>
          </div>
          <div style="margin: 20px;">
            <el-radio :label="1">用<span style="color:red;">有数据的表格</span>收集部分数据.填表人只填写部分数据,用于<span
                style="color:red;">补填、核对、修订数据</span>.</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImportSelector">取 消</el-button>
        <!--        <el-button type="default" @click="confrimNotImportDataFormName()">不 导 入</el-button>
        <el-button type="default" @click="confrimImportDataFormName()">导 入</el-button> -->
        <el-button type="primary" @click="nextStepToImport()">下一步</el-button>
      </div>
    </el-dialog>


    <!--旋转表格确认提醒-->
    <el-dialog width="40%" :close-on-click-modal="false" title="旋转表格" :visible.sync="rotateFormConfirmDialogVisible">
      <div style="font-size:22px;">
        <div style="margin: 20px;font-size:16px;">
          <div style="font-size: 20px;font-weight: bold;">为什么要旋转表格?</div>
          <div style="margin-top: 10px;">通常情况，我们填表是按照行填写的。但一些表格填表人填写是按照列填写的，为确保填表人正确填写需要将表旋转成按行填写模式.</div>
        </div>
        <div style="margin: 20px;">
          <div>如果数据量较大，可能相对比较耗时，请耐心等待！</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRotate">取 消</el-button>
        <el-button type="primary" @click="rotateForm()">立即旋转</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        excel_file: '',
        username: '',
        dataList: [],
        oldList: [],

        headList: [],
        headLabelDialogVisible: false,
        selectedHeaderLabel: '',
        selectedHeaderProp: '',
        currentHeaderContent: '',
        selectedColumnIndex: '',

        previewHeaders: [],
        previewDataList: [],

        ImportStructureAndData: false,

        active: 0,
        isCopyFormName: true,
        isCopyFormComment: false,

        startNum: 1,
        endNum: 2,

        startColumnNum: 1,
        endColumnNum: 2,

        headerPreviewData: [],
        form_titles: [],

        form_name: '',
        form_comment: '',

        options: [],
        column_inputed_value: '',
        selectColumnTitleDialogVisible: false,
        selectColumnNameDialogVisible: false,
        inputFormNameDialogVisible: false,

        tableData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        record: '', // 预览整条记录

        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [], // 选中导入字段的实际名称
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',

        settingColumnVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,

        // 预览表格的相关数据
        previewColumnLables: [],
        previewTableData: [],

        data_type: ['文本', '数字', '日期', '日期及时间', '单选', '多选', '图片', '视频', '定位'],
        is_optional: ['必须填写', '可以填写'],
        column_types: [],
        selectedColumyType: '',
        currentColumnTitle: '',
        currentColumnDescription: '',
        currentColumnSample: '',
        showColumnSample: false,

        previewHeader: [],
        imageSrc: '',
        excel_src_name: '',
        default_image_url: '/form/images/default_header.png',
        header_image_url: '',
        excel_column_count: 1,
        showRange: false,

        headRange: '',
        previewSuccess: false,

        form_headers: [],
        header_count: 0,

        selectedTypeValue: '',
        dataTypes: [{
            value: '文本',
            label: '可输入任何内容'
          },
          {
            value: '数字',
            label: '只能输入数字'
          }, {
            value: '身份证号',
            label: '只能输身份证号'
          }, {
            value: '手机号',
            label: '只能输手机号'
          }, {
            value: '日期',
            label: 'xxxx年xx月xx日'
          }, {
            value: '年月',
            label: 'xxxx年xx月'
          }, {
            value: '日期时间',
            label: 'xxxx年xx月xx日 xx点xx分'
          }, {
            value: '自动时间',
            label: '自动填入填表时间'
          }, {
            value: '日期范围',
            label: 'xxxx年xx月xx日至xxxx年xx月xx日'
          }, {
            value: '图片',
            label: '上传一张图片'
          }, {
            value: '视频',
            label: '上传一个视频文件'
          }, {
            value: '文件',
            label: '上传一个文件(doc,xls,pdf等文件)'
          }, {
            value: 'Email邮箱',
            label: '电子邮箱地址'
          }, {
            value: '车牌号',
            label: '只能输入车牌'
          }, {
            value: '签名',
            label: '手写签名'
          }, {
            value: '定位',
            label: '自动填写填表人位置'
          }
        ],

        importDataConfirmDialogVisible: false,

        is_import_data: '',
        buffered_datalist: [],
        empty_list: [],

        selectedEditTypeValue: '',
        editTypes: [{
            value: '1',
            label: '必须填写'
          },
          {
            value: '0',
            label: '可填可不填'
          }
        ],

        currentHeaderComment: '',

        import_type: '',

        DIRECTION_ROW: 'DIRECTION_ROW',
        DIRECTION_COLUMN: 'DIRECTION_COLUMN',
        table_direction: '',

        rotateFormConfirmDialogVisible: false

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      // var timestr = new Date().getTime()
      this.excel_file = this.$route.params.excel_file
      // this.endColumnNum = this.$route.params.excel_column_count
      this.loadData()
    },
    methods: {
      loadData() {
        let that = this

        var requestUrl = '/form/web/_load_preview_data.jsp'
        // 开启loading

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在解析多级表头和数据，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_file: that.excel_file,
              export_direction: that.table_direction
            }
          }).then(function(response) {
            console.log(response.data)

            that.headList = response.data.excel_data.HEADERS
            that.dataList = response.data.excel_data.EXCEL_ROWS
            that.oldList = that.dataList

            if (that.dataList.length > 0) {
              // console.log('load headlist', that.headList)

              if (that.dataList.length === 0) {
                // that.$message.error('excel导入错误,请联系客服解决!')

                return
              }

              that.rotateFormConfirmDialogVisible = false

              // console.log('datalist', that.dataList)

              that.$refs.dataList.doLayout()
            } else {
              that.$message.error('表格中可能没有数据，请检查!')
            }

            //初始化表头数据
            var firstRowData = that.dataList[0]
            console.log(response.data.excel_data)
            for (var i = 0; i < that.headList.length; i++) {
              var lableValue = firstRowData['第' + i + '列']
              // console.log(firstRowData['第' + i + '列'])
              that.headList[i].label = lableValue
              that.headList[i].data_type = '文本'
              that.headList[i].optional = '0'

            }

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },

      clickHeader(column, event) {
        var pStr = column.property
        var numArr = pStr.match(/\d+/g)
        var indexStr = numArr.join('')
        this.selectedColumnIndex = indexStr

        // console.log(pStr, 'selected index=', indexStr)

        // console.log(column, 'clickheader', event)
        let prop = column.property
        let label = ''

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            label = this.headList[i].label
            break
          }
        }

        if (this.headList[i].label === this.headList[i].prop) {
          this.currentHeaderContent = ''
          this.currentHeaderComment = ''
          this.selectedTypeValue = ''
          this.selectedEditTypeValue = ''
        } else {
          this.currentHeaderContent = label
          this.selectedTypeValue = this.headList[i].data_type

          if (this.headList[i].optional =='1') {
            this.selectedEditTypeValue = this.editTypes[1].label
          } else {
            this.selectedEditTypeValue = this.editTypes[0].label
          }

          this.currentHeaderComment = this.headList[i].comment
        }

        // this.selectedHeaderLabel = label
        this.selectedHeaderProp = prop

        this.headLabelDialogVisible = true
      },

      handleCellClick(row, column, cell, event) {

        let prop = column.property
        var pos = 0

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            pos = i
            this.selectedColumnIndex = pos
            break
          }
        }

        let value = row[prop]

        if (Utils.isEmpty(value)) {
          return
        }

        // console.log('click handleCellClick', value)

        if (this.headList[pos].label === value) {
          this.headList[pos].label = this.headList[pos].prop
          return
        }

        this.headList[pos].label = value
        this.headList[pos].optional = 0

        // console.log('表头列', this.headList[pos])

        var tmp = value.replace(/\s/g, '')
        tmp = tmp.split(' ').join('')

        if (tmp === '序号' && this.headList[pos].label === value) {
          this.$message.error('“序号”列没有意义,填表人无法录入也无从知晓,建议不要导入“序号”列!')
        }


        this.$refs.dataList.doLayout()

      },
      confirmHeaderInfo() {
        if (this.currentHeaderContent === '') {
          this.$message.error('请输入列名称')

          return
        } else {
          if (this.selectedTypeValue === '') {
            this.$message.error('请选择数据输入要求')
            return
          }
        }

        if (this.selectedEditTypeValue === '') {
          this.$message.error('请选择是否该列必须填写')
          return
        }


        for (var i = 0; i < this.headList.length; i++) {
          if (this.selectedHeaderProp === this.headList[i].prop) {
            this.headList[i].label = this.currentHeaderContent
            this.headList[i].data_type = this.selectedTypeValue

            // console.log(this.selectedEditTypeValue, this.editTypes[0].label, this.editTypes[0].value)

            if (this.selectedEditTypeValue == this.editTypes[0].value) {
              this.headList[i].optional = 0

            } else {
              this.headList[i].optional = 1
            }

            this.headList[i].comment = this.currentHeaderComment

            this.$forceUpdate()
            break
          }
        }

        this.headLabelDialogVisible = false
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''
        this.currentHeaderComment = ''
      },

      deleteHeaderInfo() {
        this.currentHeaderContent = ''
        this.currentHeaderComment = ''
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''

        this.headList[this.selectedColumnIndex].label = this.headList[this.selectedColumnIndex].prop
        // console.log('记得屏蔽窗口。。。。。', this.selectedColumnIndex)
        // console.log(this.headList)

        this.headLabelDialogVisible = false
      },

      fieldNameIsValid() {
        var isValid = true
        for (var i = 0; i < this.headList.length; i++) {
          var currentLabel = this.headList[i].label
          for (var k = i + 1; k < this.headList.length; k++) {
            if (currentLabel === this.headList[k].label) {
              isValid = false
              this.$message.error('“' + currentLabel + '”列名重复,请点击表头修改列名！')
              break
            }
          }
        }
        return isValid
      },
      hasSettingColumnName() {
        var setted = false

        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            setted = true
            break
          }
        }

        return setted
      },
      nextStep() {
        if (!this.hasSettingColumnName()) {
          this.$alert('您还没有选择任何列的数据,请点灰色的列头“第x列”设置或者点表格中的文字选择列名.', '请选择列')
          return
        }

        // this.loadPreviewHeaderData()
        if (!this.fieldNameIsValid()) {
          return
        }

        // this.importDataConfirmDialogVisible = true
        this.import_type = 0
        this.showImportPreview()
      },
      nextStepToImport() {
        this.import_type = 0 //关闭掉

        if (this.import_type === '') {
          this.$message.error('请选择导入表格用途！')
          return
        }

        if (this.import_type === 0) {
          this.is_import_data = false
          this.ImportStructureAndData = false
        } else {
          this.is_import_data = true
          this.ImportStructureAndData = true
        }

        this.showImportPreview()
      },
      confrimImportDataFormName() {
        this.is_import_data = true
        this.ImportStructureAndData = true
        this.showImportPreview()
      },
      confrimNotImportDataFormName() {
        this.is_import_data = false
        this.ImportStructureAndData = false
        this.showImportPreview()
      },
      showImportPreview() {
        this.previewDataList = []
        this.empty_list = []

        this.buffered_datalist = this.dataList
        console.log(this.buffered_datalist)
        // 开启loading
        // const load = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })

        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            let header = {
              prop: this.headList[i].prop,
              label: this.headList[i].label,
              data_type: this.headList[i].data_type,
              optional: this.headList[i].optional,
              comment: this.headList[i].comment
            }

            this.previewDataList.push(header)
          }

          var cName = this.headList[i].prop
          let emptyItem = {}
          emptyItem[cName] = ''
          this.empty_list.push(emptyItem)
        }
        // load.close()

        // console.log('this.previewDataList==', this.previewDataList)

        if (this.is_import_data === false) {
          this.dataList = this.empty_list
        } else {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
        }

        this.selectColumnTitleDialogVisible = true
      },
      filterList(buffered_datalist, selectHeaderList) {
        let tmpList = []

        for (var i = 0; i < buffered_datalist.length; i++) {
          let row = buffered_datalist[i]
          // console.log('row=', row)

          var tmpstr = ''
          for (var j = 0; j < selectHeaderList.length; j++) {
            var headerName = selectHeaderList[j].prop
            // console.log('header==', selectHeaderList[j].prop)
            var cellValue = '' + row[headerName]
            cellValue = cellValue.trim()
            tmpstr = tmpstr + cellValue
            console.log(tmpstr)
          }

          if (!Utils.isEmpty(tmpstr)) {
            tmpList.push(row)
          }
        }

        return tmpList
      },
      nextPage() {
        var tmpDataList = JSON.stringify(this.dataList)
        var finalHeaderList = JSON.stringify(this.previewDataList)
        // var paperScoreList = encodeURIComponent(JSON.stringify(this.paperScores))

        // console.log('dataList', tmpDataList)
        // console.log('finalHeaderList', finalHeaderList)

        var import_data = '1'

        if (this.ImportStructureAndData) {
          import_data = '1'
        } else {
          import_data = '0'
        }

        console.log('this.dataList=', this.dataList)

        this.$router.push({
          name: 'excel_data_import_final_step',
          params: {
            dataList: tmpDataList,
            headList: finalHeaderList,
            import_data: import_data
          }
        })
      },
      preStep() {
        if (this.active > 0) {
          this.active = this.active - 1
        }
      },
      back() {
        this.$router.back()
      },

      cancelPreviewSetting() {
        this.previewColumnLables.length = 0
        this.dialogFormVisible = false
        this.previewTableData.length = 0
      },
      closeDialog() {
        this.showRange = false
        this.selectColumnTitleDialogVisible = false
        this.previewSuccess = false
      },
      convertHeader(label) {
        if (label == null || label === 'null') {
          return ''
        } else {
          return label
        }
      },
      deleteRow(index, dataList) {
        dataList.splice(index, 1)
        this.$forceUpdate()
      },
      checkImportStateChange(checked) {
        console.log(checked)
        if (checked === true) {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
          this.is_import_data = true
        } else {
          this.dataList = this.empty_list
          this.is_import_data = false
        }

        this.$forceUpdate()
      },
      changeImportType(value) {
        // console.log('****>>>>', value)
        this.dataList = this.oldList
        // if (value === '0') {
        //   this.dataList = this.oldList
        //   // 恢复数据
        // }
      },
      closeImportSelector() {
        this.dataList = this.oldList
        this.importDataConfirmDialogVisible = false
      },
      headListIsEmpty(headList) {
        if (Utils.isEmpty(headList)) {
          return true
        } else {
          var isEmpty = true
          for (var i = 0; i < headList.length; i++) {
            var tmpLabel = headList[i].label
            // console.log(tmpLabel)
            var cName = '第' + i + '列'
            if (tmpLabel == cName) {
              continue
            } else {
              isEmpty = false
              break
            }
          }

          // console.log('ddddddddddddddddddd',isEmpty)

          return isEmpty
        }
      },
      allSetWrite() {

        // console.log(this.headList)

        if (this.headListIsEmpty(this.headList)) {
          this.$message.error('还未选择任何列，请选择列后再操作！')
          return
        }

        for (var i = 0; i < this.headList.length; i++) {
          this.headList[i].optional = 0
        }

        this.$forceUpdate()
      },
      allSetWriteBorbid() {
        if (this.headListIsEmpty(this.headList)) {
          this.$message.error('还未选择任何列，请选择列后再操作！')
          return
        }

        for (var i = 0; i < this.headList.length; i++) {
          this.headList[i].optional = 1
        }

        this.$forceUpdate()
      },
      reverseWrite() {
        if (this.headListIsEmpty(this.headList)) {
          this.$message.error('还未选择任何列，请选择列后再操作！')
          return
        }

        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].optional === 1) {
            this.headList[i].optional = 0
          } else {
            this.headList[i].optional = 1
          }
        }

        this.$forceUpdate()
      },
      transitionTable() {

        this.rotateFormConfirmDialogVisible = true


      },
      cancelRotate() {
        this.rotateFormConfirmDialogVisible = false
      },
      rotateForm() {
        if (Utils.isEmpty(this.table_direction) || this.table_direction == this.DIRECTION_ROW) {
          this.table_direction = this.DIRECTION_COLUMN
        } else {
          this.table_direction = this.DIRECTION_ROW
        }

        //清空
        this.headList = []

        this.loadData()
      }


    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    width: 15px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    /*滚动条的背景区域的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(238, 238, 238, 0.3);
    background-color: #eeeeee;
    /*滚动条的背景颜色*/
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    /*滚动条的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(145, 143, 0143, 0.3);
    background-color: rgb(145, 143, 143);
    /*滚动条的背景颜色*/
  }

  .el-radio /deep/ .el-radio__label {

    font-size: 16px !important;

  }
</style>



// WEBPACK FOOTER //
// src/components/excel_data_preview.vue